module.exports = __webpack_public_path__ + "img/itware_logo.f480b6f1.png";